import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import React from 'react';
import downloadSmallTokens from '@amzn/meridian-tokens/base/icon/download-small';

interface LinkValue {
  title: string;
  link: string;
}

interface LinkContentProps {
  content: Array<LinkValue> ;
  onDownloadBtnClick: (value: string) => void;
}

const LinkContent: React.FC<LinkContentProps> = ({content, onDownloadBtnClick}) => (
  <Column>
    {content.map((knowledgeLink) => {
      if (knowledgeLink.title?.includes('Download Manual')) {
        return (
          <Row>
            <Button
              type='link'
              onClick={() => onDownloadBtnClick(knowledgeLink?.link)}
                >{knowledgeLink?.title}<Icon tokens={downloadSmallTokens} /></Button>
          </Row>
        );
      }
      // eslint-disable-next-line react/no-array-index-key
      return (
        <Row>
          <Button
            type='link'
            onClick={() => window.open(knowledgeLink?.link)}
                >{knowledgeLink?.title}</Button>
        </Row>  
      ); 
    })}
  </Column>
);

export default LinkContent;